import { getUrl, getSSIUrl } from "@xo-union/dist-url";
var DIST_NAME = 'tk-pagelet-footer-nav';
export var getFooterAssetUrl = function getFooterAssetUrl(tag, path) {
  return getUrl({
    params: {
      name: DIST_NAME,
      tag: tag,
      path: path
    }
  });
};
export var getFooterSSIUrl = function getFooterSSIUrl(tag, path) {
  return getSSIUrl({
    params: {
      name: DIST_NAME,
      tag: tag,
      path: path
    }
  });
};
export var KNOT_HOST_MAP = {
  qa: 'https://qa-beta.theknot.com',
  production: 'https://www.theknot.com'
};